import { tickerItems } from '@/mocks/heiliao';

export default function TickerBar() {
  return (
    <section id="today" className="w-full border-y border-primary-600 bg-primary-500" aria-label="今日速览快讯">
      <div className="mx-auto flex max-w-[1400px] items-center gap-4 px-4 py-3.5 md:px-8">
        <span className="flex shrink-0 items-center gap-2 rounded-sm bg-foreground-950 px-3 py-1.5 text-xs font-semibold tracking-wider text-accent-400">
          <i className="ri-flashlight-fill"></i>
          今日速览
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            <ul className="flex shrink-0 items-center gap-10 pr-10">
              {tickerItems.map((text) => (
                <li
                  key={text}
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-background-50"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
                  {text}
                </li>
              ))}
            </ul>
            <ul className="flex shrink-0 items-center gap-10 pr-10" aria-hidden="true">
              {tickerItems.map((text) => (
                <li
                  key={`dup-${text}`}
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-background-50"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}